module.exports = __webpack_public_path__ + "static/media/logo-white.13492e7c.svg";